import React, { useEffect, useState } from "react";
import { useAuthContext } from "@src/context";
import { useToastContext } from "@src/context/toastContext";
import AdminHooks from "@src/context/hooks/adminHooks";
import { Loader, Modal } from "@src/components/atoms";
import { InAppNotificationViewModal } from "@src/components/cards/operator/InAppNotificationViewModal";

/** Embeds a PDF. source can be either Bytes or a data uri */
const PdfViewer = ({ source, width = "100%", height = 700 }) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    let objectUrl = null;

    if (typeof source === "string") {
      if (source.startsWith("data:")) {
        //Data URI
        setUrl(source);
      } else {
        console.error(
          "Invalid PDF string. Must be a data URL starting with 'data:'",
        );
      }
    } else {
      // Raw bytes
      const blob = new Blob([source], { type: "application/pdf" });
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [source]);

  if (!source) return null;
  if (!url) return <Loader />;

  return (
    <iframe
      src={url + "#toolbar=0"}
      width={width}
      height={height}
      style={{ border: "none", minHeight: `${height}px` }}
    />
  );
};

/** Gets the entire notification with all properties, and outputs: Formatted JSON, and a preview if possible */
const NotificationDetailModal = ({ notificationId, handleClose }) => {
  const auth = useAuthContext();
  const { showToast } = useToastContext();
  const {
    data: notification,
    isFetching,
    isError,
    //error: errorAll,
  } = AdminHooks.useGetSingleNotification(auth.activeRole, notificationId);

  if (isError) {
    showToast("error fetching notification details", "error");
  }

  const htmlContent = notification?.data?.htmlContent;
  const pdfAttachment = notification?.attachments?.find((a) => !!a.pdf);
  const dataDump = (
    <pre className="min-h-96 p-4 max-w-full overflow-auto text-xs">
      {JSON.stringify(notification, null, 2)}
    </pre>
  );

  return (
    <Modal size="email" open={notificationId != null} handleClose={handleClose}>
      <>
        {isFetching ? (
          <Loader size="2xl" />
        ) : isError ? (
          <>Error fetching Notification</>
        ) : (
          <>
            {dataDump}
            {htmlContent != null ? (
              <div>
                <InAppNotificationViewModal
                  open={true}
                  notificationHtml={
                    /* prevent <a> from being clicked so we don't track it as a click */
                    htmlContent.replace(
                      /<a\s+([^>]*?)href=/gi,
                      "<a $1href='#' onclick='event.preventDefault()'",
                    )
                  }
                  handleClose={handleClose}
                  asModal={false}
                />
              </div>
            ) : pdfAttachment != null ? (
              <>
                displaying PDF "{pdfAttachment.name}"
                <PdfViewer source={pdfAttachment.pdf} />
              </>
            ) : (
              <>
                Could not display a preview (Need either INAPP, or an attached
                PDF)
              </>
            )}
          </>
        )}
      </>
    </Modal>
  );
};
export default NotificationDetailModal;
